/**
 * 整理されてない関数の置場。いずれまとめる。
 */
import { CORE_CONSTANT, type ViewConfig } from '@salescore/core'

export const getBackgroundViewId = (
  viewId: string,
  previousView: { id: string; config: { type: ViewConfig['type'] } } | undefined,
): string | undefined =>
  previousView?.config.type === 'kpiPivot'
    ? previousView.id
    : // eslint-disable-next-line sonarjs/no-nested-conditional
      viewId.startsWith(CORE_CONSTANT.KPI_SHEET_DYNAMIC_VIEW_ID_PREFIX)
      ? viewId.slice(CORE_CONSTANT.KPI_SHEET_DYNAMIC_VIEW_ID_PREFIX.length)
      : viewId
